/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1CustomFromJSON, InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1CustomToJSON, } from './InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1Custom';
/**
 * Check if a given object implements the InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1 interface.
 */
export function instanceOfInternalAdminWhitelabelRequestV4SslCertificateDataOneOf1(value) {
    if (!('custom' in value) || value['custom'] === undefined)
        return false;
    return true;
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1FromJSON(json) {
    return InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1FromJSONTyped(json, false);
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'custom': InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1CustomFromJSON(json['custom']),
    };
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1ToJSON(json) {
    return InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1ToJSONTyped(json, false);
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'custom': InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1CustomToJSON(value['custom']),
    };
}
